import CardWrapper from '../../components/wrapper/card';
import CreateFormComponent from '../../components/forms/create_form';
import { fetchFormsThunk } from '../../redux/thunks/form';
import FormComponent from '../../components/forms';
import LeadComponent from '../../components/lead';
import SelectedFormComponent from '../../components/forms/selected_form';
import SelectedLeadComponent from '../../components/lead/selected_lead';
import { settingSelectedTabFromLead } from '../../redux/slices/leads';
import { useParams } from 'react-router';
import { a11yProps, CustomTabPanel } from '../deals';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const LeadManagementPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams<{ id: string }>();
  const { selectedTab, selectedLeadFlag, selectedLead } = useSelector((state: RootState) => state.lead);
  const { isCreatingFormFlag, selectedFormFlag, selectedForm } = useSelector((state: RootState) => state.form);

  const handleChange = (event: React.SyntheticEvent, newValue: 0 | 1) => {
    dispatch(settingSelectedTabFromLead(newValue));
  };

  useEffect(() => {
    const fetchForms = async () => {
      try {
        await dispatch(fetchFormsThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
      } catch (e) {
        // Catch erorrs
      }
    };
    fetchForms();
  }, []);

  if (selectedLeadFlag && selectedLead) {
    return <Box padding={id ? '0' : '15px 15px 60px 15px'} pb="100px"><SelectedLeadComponent /></Box>;
  } else if (selectedFormFlag && selectedForm) {
    return <Box padding={id ? '0' : '15px 15px 60px 15px'} pb="100px"><SelectedFormComponent /></Box>;
  } else if (isCreatingFormFlag) {
    return <Box padding={id ? '0' : '15px 15px 60px 15px'} pb="100px"><CreateFormComponent /></Box>;
  }

  return (
    <Box padding={id ? '0' : '15px 15px 60px 15px'} pb="100px">
      <CardWrapper minHeight="80vh" overflow="auto">
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          aria-label="Leads and Forms details tabs"
        >
          <Tab
            label="Leads"
            {...a11yProps(0)}
          />
          <Tab
            label="Forms"
            {...a11yProps(1)}
          />
        </Tabs>

        <CustomTabPanel value={selectedTab} index={0}>
          <LeadComponent />
        </CustomTabPanel>

        <CustomTabPanel value={selectedTab} index={1}>
          <FormComponent />
        </CustomTabPanel>
      </CardWrapper>
    </Box>
  );
};

export default LeadManagementPage;